import { cn } from "@/lib/utils";

/**
 * The Complete Athlete monogram on a primary tile. The same drawing as
 * `src/assets/images/icon.png` and the favicons, traced from
 * `src/assets/original/ca_sygnet_mono_white.svg`.
 *
 * Inlined rather than imported as a file so it inherits `currentColor` and follows the theme: the
 * mark sits dark on the lime tile here, and the same component can be dropped on any surface.
 * The monogram is taller than it is wide, so the height is fixed and the width follows.
 */
export const BrandMark = ({ className }: { className?: string }) => (
  <span
    aria-hidden
    className={cn(
      "grid size-[30px] shrink-0 place-items-center rounded-[10px] bg-primary text-primary-foreground",
      className,
    )}
  >
    <svg viewBox="0 0 68.77 93.11" fill="currentColor" className="h-[17px] w-auto">
      <polygon points="32.44 0 32.44 17.91 22 17.91 22 10.45 10.44 10.45 10.44 56.35 22 67.91 22 57.8 32.44 57.8 32.44 93.11 0 60.67 0 4.45 4.45 0 32.44 0" />
      <path d="M64.32,0h-27.99v93.11l5.44-5.43,5-5.01v-42h11.56v30.44l10.44-10.44V4.44l-4.45-4.44ZM58.33,30.23h-11.56V10.45h11.56v19.78Z" />
    </svg>
  </span>
);
